import React from "react";
import ProfileMobileContainer from "../../containers/ProfileMobileContainer/ProfileMobileContainer";

const ProfileMobilePage = () => {
  return <ProfileMobileContainer />;
};
export default ProfileMobilePage;
